<template>
  <!-- Modal -->
  <div class="modal fade" id="ChildDeleteConfirmModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content pb-3">
        <div class="modal-header py-2">
          <h5 class="modal-title" ><trans-text i18nKey="ui['5_3_1'][1]" :isHtml="true"/></h5>
        </div>

        <div class="modal-body" style="padding-bottom:2rem;">
        </div>

        <!-- フォーム送信UI -->
        <div class="row text-center">
          <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
            <div class="my-1">
              <button type="button" class="btn w-100 btn-lg btn-defalut" @click="cancel" ><trans-text i18nKey="ui['5_3_1'][2]" :isHtml="true"/></button>
            </div>
          </div>
        </div>

        <!-- フォーム送信UI -->
        <div class="row text-center">
          <div class="offset-1 offset-sm-2 offset-md-3 col-10 col-sm-8 col-md-6">
            <div class="my-1">
              <button type="button" class="btn w-100 btn-lg btn-warning" @click="remove" ><trans-text i18nKey="ui['5_3_1'][3]" :isHtml="true"/></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import Order from 'processor/Order'
  export default {
    props:["input"],
    components: {
    },
    data () {
      return {
      }
    },
    created(){
    },
    methods:{
      cancel(){
        $("#ChildDeleteConfirmModal").modal("hide")
      },
      remove(){
          this.$emit("remove")

//        app.make("axios").post(`v1/password-verify`,this.input)
//          .then(({data}) =>{
//            this.$router.push({name:"password-remind-complete"})
//          })
//          .catch(error => {
//            this.apiErrorI18nKey = "error[15][2]"
//          })
      },
    }

  }
  //
  //DIコンテナ作成

  //alert("test");

</script>

<style lang="scss" scoped>
  .modal-header{
    background-color: #fef7ea;
  }

  .modal-body{
    font-size: .9rem;
  }
</style>



// WEBPACK FOOTER //
// ChildDeleteConfirmModal.vue?7b0747c5